import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  createProblemContactMessage,
  createReport,
  deleteProblemContactMessage,
  listProblemContactMessages,
} from '../services/contentService';
import { ensureUserProfile } from '../services/profileService';

function ProblemContactChat({ request }) {
  const { currentUser } = useAuth();
  const [messages, setMessages] = useState([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const loadMessages = useCallback(async () => {
    if (!request?.id) return;
    setLoading(true);
    setError('');
    try {
      setMessages(await listProblemContactMessages(request.id));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [request]);

  useEffect(() => {
    loadMessages();
  }, [loadMessages]);

  async function handleSubmit(event) {
    event.preventDefault();
    setMessage('');
    setError('');
    try {
      if (!text.trim()) return;
      const profile = await ensureUserProfile(currentUser);
      await createProblemContactMessage(request, profile, text);
      setText('');
      await loadMessages();
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDelete(messageId) {
    setMessage('');
    setError('');
    try {
      await deleteProblemContactMessage(request.id, messageId);
      await loadMessages();
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleReport(chatMessage) {
    setMessage('');
    setError('');
    try {
      await createReport(currentUser.uid, 'problemMessage', `${request.id}/${chatMessage.id}`, 'Harmful, unsafe, or inappropriate private message');
      setMessage('Message reported.');
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <div className="problem-chat">
      <p className="tag">Private problem thread</p>
      {error ? <p className="error-text">{error}</p> : null}
      {message ? <p className="notice">{message}</p> : null}
      {loading ? <p className="muted">Loading messages...</p> : null}
      {!loading && messages.length === 0 ? <p className="muted">No messages yet. Keep it practical, respectful, and privacy-aware.</p> : null}
      <div className="problem-chat-messages">
        {messages.map((chatMessage) => (
          <article className={`problem-chat-message ${chatMessage.authorId === currentUser?.uid ? 'own-message' : ''}`} key={chatMessage.id}>
            <strong>{chatMessage.authorName}</strong>
            <p>{chatMessage.text}</p>
            <div className="button-row compact-row comment-actions">
              {chatMessage.authorId === currentUser?.uid ? (
                <button className="button button-secondary button-small" type="button" onClick={() => handleDelete(chatMessage.id)}>Delete</button>
              ) : null}
              {chatMessage.authorId !== currentUser?.uid ? (
                <button className="button button-secondary button-small" type="button" onClick={() => handleReport(chatMessage)}>Report</button>
              ) : null}
            </div>
          </article>
        ))}
      </div>
      <form className="comment-form problem-chat-form" onSubmit={handleSubmit}>
        <input value={text} onChange={(event) => setText(event.target.value)} placeholder="Write a private, consent-based message" />
        <button className="button button-secondary button-small" type="submit">Send</button>
      </form>
    </div>
  );
}

export default ProblemContactChat;
